import { GeneralInfo } from './../../../VIewModels/TowLocateViewModels/GeneralInfo';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { TowLocateSubjectService } from './../../../services/TowLocateServices/tow-locate-subject.service';
import { Common } from './../../../common/common';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { StateArray } from './../../../data/states';
import { Component, OnInit } from '@angular/core';
import { SearchByVinViewModel } from '../../../ViewModels/TowLocateViewModels/SerchbyVinViewModel';
import { PlateSearch } from '../../../VIewModels/TowLocateViewModels/PlateSearch';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MultipleResultServiceService } from '../../../Services/TowLocateServices/multiple-result-service.service';
import { PartialSearchRequest } from '../../../VIewModels/TowLocateViewModels/PartialSearchRequest';
@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  public commonFunctions = new Common();
  public vinEntry: string = "";
  public PlateInfo = new PlateSearch();
  public PartialSearch = new PartialSearchRequest();
  public searchTypeId: number;
  public States = StateArray;
  public form: FormGroup;
  public data = new SearchByVinViewModel();
  public invalidVin = false;
  public formFlag = true;

  get fSearchType() {
    return this.form.get('fSearchType');
  }
  get fplateInfo() {
    return this.form.get('fplateInfo');
  }
  get fstateInfo() {
    return this.form.get('fstateInfo');
  }
  get fvinInfo() {
    return this.form.get('fvinInfo');
  }
  get fauctionEarliestInfo(){
    return this.form.get('fauctionEarliestInfo');
  }
  get fauctionLatestInfo(){
    return this.form.get('fauctionLatestInfo');
  }
  get fmakeInfo(){
    return this.form.get('fmakeInfo');
  }
  get fmodelInfo(){
    return this.form.get('fmodelInfo');
  }
  get fyearInfo(){
    return this.form.get('fyearInfo');
  }
  get fcityInfo(){
    return this.form.get('fcityInfo');
  }
  get fpostalInfo(){
    return this.form.get('fpostalInfo');
  }
  searchType = [
    { id: null, name: 'Select Search Type' },
    { id: 1, name: 'Plate/Tag' },
    { id: 2, name: 'VIN' },
    { id: 3, name: 'Other'}
  ];
  constructor(private formBuilder: FormBuilder, public TowService: TowLocateSubjectService,
    public router: Router, public client: HttpClient, private spinnerService: Ng4LoadingSpinnerService,
    public MultipleSubjectresult: MultipleResultServiceService) { }

  ngOnInit() {
    this.searchTypeId = null

    this.form = this.formBuilder.group({
      fSearchType: [null, Validators.required],
      fplateInfo: [null, Validators.required],
      fstateInfo: [null, Validators.required],
      fvinInfo: [null, [Validators.required,Validators.minLength(6)]],
      fauctionEarliestInfo: [null],
      fauctionLatestInfo: [null],
      fmakeInfo: [null],
      fmodelInfo: [null],
      fyearInfo: [null],
      fcityInfo: [null],
      fpostalInfo: [null]
    });
  }

  public onDropDownChange(event: any): void {  // event will give you full breif of action
    if (event == 1) {
      this.ClearValidators(2);
      this.fplateInfo.setValidators([Validators.required]);
      this.fstateInfo.setValidators([Validators.required]);
      this.fplateInfo.updateValueAndValidity();
      this.fstateInfo.updateValueAndValidity();
    }
    else if (event == 2) {
      this.ClearValidators(1);
      this.fvinInfo.setValidators([Validators.required,Validators.minLength(6)]);
      this.fvinInfo.updateValueAndValidity();
    }
    else if (event == 3) {
      this.ClearValidators(1);
      this.ClearValidators(2);
    }
  }

  public ClearValidators(selection: number){
    if(selection === 1){
      console.log("clearing Plate Validator");
      this.fplateInfo.clearValidators();
      this.fstateInfo.clearValidators();
      this.fplateInfo.updateValueAndValidity();
      this.fstateInfo.updateValueAndValidity();
    }
    else if (selection === 2){
      console.log("clearing Vin Validator");
      this.fvinInfo.clearValidators();
      this.fvinInfo.updateValueAndValidity();
    }
  }

  public ForceSearch() {
    this.spinnerService.show();
    const httpOptions =
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
    this.client.post<SearchByVinViewModel>('https://towlienapiprod.azurewebsites.net/api/TowLocate/SearchVin', JSON.stringify(this.vinEntry), httpOptions).subscribe(data => {
      this.TowService.changeMessage(data);
      this.spinnerService.hide();
      this.router.navigate([`/Results`])
    });
  }

  public GoBack() {
    this.formFlag = true;
    this.invalidVin = false;
  }

  public Continue() {
    if(this.searchTypeId == 3){
      this.spinnerService.show();

      const httpOptions =
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          })
        };

      this.client.post<Array<GeneralInfo>>('https://towlienapiprod.azurewebsites.net/api/TowLocate/PartialCriteria', this.PartialSearch, httpOptions).subscribe(data => {
        this.MultipleSubjectresult.changeMessage(data);
        this.spinnerService.hide();
        this.router.navigate([`/MultiSelect`]);
        console.log(data.length);
      });
    }
    else if (this.form.valid) {
      if (this.searchTypeId == 2) {
        this.spinnerService.show();
        const httpOptions =
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            })

          };
        this.client.post<Array<GeneralInfo>>('https://towlienapiprod.azurewebsites.net/api/TowLocate/PartialVin', JSON.stringify(this.vinEntry), httpOptions).subscribe(data => {
          if (data.length > 1) {
            this.MultipleSubjectresult.changeMessage(data);
            this.spinnerService.hide();
            this.router.navigate([`/MultiSelect`]);
            console.log(data.length);
          }
          else if (data.length == 1) {
            console.log(data[0].vin)
            this.client.post<SearchByVinViewModel>('https://towlienapiprod.azurewebsites.net/api/TowLocate/SearchVin',
              JSON.stringify(data[0].vin), httpOptions)
              .subscribe(data => {
                this.TowService.changeMessage(data);
                this.spinnerService.hide();
                this.router.navigate([`/Results`]);
              });
          }
          else {
            this.spinnerService.hide();
            this.formFlag = false;
            this.invalidVin = true;
          }

        })
        //   this.client.post<boolean>('https://towlienapidev.azurewebsites.net/api/Decode/ValidateVin',JSON.stringify(this.vinEntry),httpOptions).subscribe(data=>{
        //     if(data)
        //     {
        //       this.client.post<SearchByVinViewModel>('https://towlienapidev.azurewebsites.net/api/TowLocate/SearchVin',JSON.stringify(this.vinEntry),httpOptions).subscribe(data=>{    
        //         this.TowService.changeMessage(data);
        //         this.spinnerService.hide();
        //     this.router.navigate([`/Results`])
        // });
        //     }
        //     else
        //     {this.spinnerService.hide();
        //       this.formFlag=false;
        //       this.invalidVin=true;
        //     }
        //   });

      }
      else if (this.searchTypeId == 1) {
        this.spinnerService.show();

        const httpOptions =
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            })
          };

        this.client.post<SearchByVinViewModel>('https://towlienapiprod.azurewebsites.net/api/TowLocate/SearchByPlate', this.PlateInfo, httpOptions).subscribe(data => {
          this.TowService.changeMessage(data);
          this.spinnerService.hide();
          this.router.navigate([`/Results`])


        });
      }
    }
    else {
      this.commonFunctions.validateAllFormFields(this.form);
    }

  }
}




// WEBPACK FOOTER //
// ./src/app/Components/TowLocate/home-page/home-page.component.ts